import { downloadBlob, postForFile } from './batch3Api';

export { downloadBlob };

export type VatSource = 'xero' | 'quickbooks';

export interface VatSummary {
  files: string[];
  stats: {
    total_vat_transactions: number;
    total_no_vat_transactions: number;
    total_vat_amount: number;
    total_net_amount: number;
    by_box?: Record<string, number>;
  };
}

export interface VatOptions {
  source: VatSource;
  financialYearEnd: string; // YYYY-MM-DD
  manualQuarterMonth: string | null;
  manualQuarterYear: number | null;
}

export function summariseVat(files: File[], options: VatOptions) {
  const form = new FormData();
  files.forEach((f) => form.append('input_files', f));
  form.append(
    'options',
    JSON.stringify({
      source_type: options.source,
      financial_year_end: options.financialYearEnd,
      manual_quarter_month: options.manualQuarterMonth,
      manual_quarter_year: options.manualQuarterYear,
    })
  );
  return postForFile<VatSummary>('/vat-agent/summarise', form, 'VAT_Summary.xlsx', 'VAT processing failed');
}
